/* mx-global.js */

document.addEventListener("DOMContentLoaded", () => {
  
  // 1. LENIS SMOOTH SCROLL SETUP
  if (typeof Lenis !== 'undefined') {
    const lenis = new Lenis({
      duration: 1.2,
      easing: (t) => Math.min(1, 1.001 - Math.pow(2, -10 * t)),
      smooth: true,
    });

    if (typeof ScrollTrigger !== 'undefined' && typeof gsap !== 'undefined') {
      lenis.on('scroll', ScrollTrigger.update);
      gsap.ticker.add((time) => {
        lenis.raf(time * 1000);
      });
      gsap.ticker.lagSmoothing(0, 0);
    } else {
      requestAnimationFrame(function raf(time) {
        lenis.raf(time);
        requestAnimationFrame(raf);
      });
    }
  }

  // 2. GLOBAL SCROLL ANIMATIONS (GSAP)
if (typeof gsap !== 'undefined' && typeof ScrollTrigger !== 'undefined') {
    gsap.registerPlugin(ScrollTrigger);

    // Animate Up
    ScrollTrigger.batch(".mx-animate-up", {
      start: "top 85%",
      once: true,
      onEnter: (batch) => gsap.to(batch, { 
        opacity: 1, 
        y: 0, 
        duration: 1.6,       // Increased from 1 to 1.6
        stagger: 0.25,       // Increased from 0.15 to 0.25 for a better sequence
        ease: "power2.out",  // Changed to power2.out (slightly smoother, less snappy than power3)
        overwrite: true 
      })
    });

    // Animate Right
    ScrollTrigger.batch(".mx-animate-right", {
      start: "top 85%",
      once: true,
      onEnter: (batch) => gsap.to(batch, { 
        opacity: 1, 
        x: 0, 
        duration: 1.6,       // Increased from 1 to 1.6
        stagger: 0.25, 
        ease: "power2.out", 
        overwrite: true 
      })
    });

    // Animate Left
    ScrollTrigger.batch(".mx-animate-left", {
      start: "top 85%",
      once: true,
      onEnter: (batch) => gsap.to(batch, { 
        opacity: 1, 
        x: 0, 
        duration: 1.6,       // Increased from 1 to 1.6
        stagger: 0.25, 
        ease: "power2.out", 
        overwrite: true 
      })
    });

    // Unmask Reveal
    ScrollTrigger.batch(".mx-unmask", {
      start: "top 85%",
      once: true,
      onEnter: (batch) => gsap.to(batch, { 
        clipPath: "inset(0% 0% 0% 0%)", 
        duration: 1.8,       // Increased from 1.2 to 1.8 for a very elegant reveal
        stagger: 0.3,        // Increased stagger
        ease: "power2.inOut", 
        overwrite: true 
      })
    });
  }
});